import {
  getBillInfo,
} from "@/api/payment2";
import editSeats from "./edit-seats";
import card from "./card";

export default {
  namespaced: true,
  state: {
    commodity: null,
    bills: {},
  },
  mutations: {
    SET_COMMODITY(state, payload) {
      state.commodity = payload;
    },
    SET_BILLS(state, payload) {
      if (payload.card.nextBill) {
        payload.card.nextBill = Number(payload.card.nextBill) || 0
      }
      state.bills = payload;
    },
  },
  actions: {
    async getBillInfo({ commit }) {
      await getBillInfo().then((res) => {
        const data = res.data;
        commit("SET_BILLS", data);
      }).catch((error) => {
        Promise.reject(error);
      })
    },
  },
  modules: {
    editSeats,
    card,
  }
}
